// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide-item[data-v-f1dbdeb8]{display:none}.password-validator[data-v-f1dbdeb8]{margin-top:.5rem;font-weight:600}.password-validator .passStrengthWeak[data-v-f1dbdeb8]{color:#b7213c}.password-validator .passStrengthGood[data-v-f1dbdeb8]{color:#ff9720}.password-validator .passStrengthStrong[data-v-f1dbdeb8]{color:#21a330}.security-section[data-v-f1dbdeb8]{border:1px solid #bbbfc9}.security-section[data-v-f1dbdeb8]:not(:first-child){margin-top:-1px}", ""]);
// Exports
module.exports = exports;
